import { ALLERGEN_MAP } from '../utils/allergens';

interface AllergenModalProps {
  onClose: () => void;
}

const ALLERGENS = Object.entries(ALLERGEN_MAP).filter(([code]) => isNaN(Number(code)));
const ADDITIVES = Object.entries(ALLERGEN_MAP).filter(([code]) => !isNaN(Number(code)));

const THIRD = Math.ceil(ALLERGENS.length / 3);
const COL1 = ALLERGENS.slice(0, THIRD);
const COL2 = ALLERGENS.slice(THIRD, THIRD * 2);
const COL3 = ALLERGENS.slice(THIRD * 2);

export function AllergenModal({ onClose }: AllergenModalProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '52rem' }}>
        <div className="modal-header">
          <div>
            <div className="modal-title">Allergene & Zusatzstoffe</div>
            <div className="modal-subtitle">Alle verwendeten Codes</div>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Schließen" />
        </div>
        <div className="modal-body">

          <div style={{ fontSize: '0.688rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.625rem' }}>
            Allergene
          </div>
          <div className="allergen-grid">
            {[COL1, COL2, COL3].map((col, ci) => (
              <div key={ci} className="allergen-list">
                {col.map(([code, label]) => (
                  <div key={code} className="allergen-item">
                    <span className="allergen-code">{code}</span>
                    <span className="allergen-desc">{label}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div style={{ fontSize: '0.688rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '1.25rem 0 0.625rem' }}>
            Zusatzstoffe
          </div>
          <div className="allergen-grid">
            {[
              ADDITIVES.slice(0, 4),
              ADDITIVES.slice(4, 7),
              ADDITIVES.slice(7),
            ].map((col, ci) => (
              <div key={ci} className="allergen-list">
                {col.map(([code, label]) => (
                  <div key={code} className="allergen-item">
                    <span className="allergen-code">{code}</span>
                    <span className="allergen-desc">{label}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div style={{ marginTop: '1rem', fontSize: '0.75rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>
            Spuren einzelner Allergene können nicht ausgeschlossen werden.
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Schließen</button>
          </div>
        </div>
      </div>
    </div>
  );
}
